export const TenantSetting = Object.freeze({
	LIVE_STOCK: 1,
	PRODUCT_INCLUDE_TAX_RATE: 2,
	HAVE_DIGITAL_PRODUCTS: 3,
	PUSH_UPDATE_TO_MARKETPLACES: 5,
});
